import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <header className={styles.header}>
                    <h1 className={styles.title}>Privacy Policy</h1>
                    <p className={styles.lastUpdated}>
                        Last updated: {new Date().toLocaleDateString()}
                    </p>
                </header>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Introduction</h2>
                    <p className={styles.paragraph}>
                        Welcome to <strong>Swag – For Contracting & Real Estate Development</strong>.
                        This Privacy Policy explains how we collect, use, and protect your
                        information when you use our mobile application. Please read it carefully.
                        If you do not agree with this policy, please do not use the application.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Information We Collect</h2>

                    <h3 className={styles.subsectionTitle}>Personal Information</h3>
                    <p className={styles.paragraph}>
                        We may collect personal information that you provide directly to us when
                        using the app, including:
                    </p>
                    <ul className={styles.list}>
                        <li>Name and contact information (email, phone number)</li>
                        <li>Address information related to purchased units</li>
                        <li>Account login credentials</li>
                    </ul>

                    <h3 className={styles.subsectionTitle}>Property & Contract Information</h3>
                    <p className={styles.paragraph}>
                        To provide you with updates and services, we may collect:
                    </p>
                    <ul className={styles.list}>
                        <li>Details of purchased units and contracts</li>
                        <li>Installment schedules and payment status</li>
                        <li>Maintenance requests and ticket history</li>
                    </ul>

                    <h3 className={styles.subsectionTitle}>Usage & Device Information</h3>
                    <p className={styles.paragraph}>
                        We may collect limited technical data to improve app performance, such as:
                    </p>
                    <ul className={styles.list}>
                        <li>Device type and operating system</li>
                        <li>App version and performance logs</li>
                        <li>Crash reports and diagnostics</li>
                        <li>Notification preferences</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>How We Use Your Information</h2>
                    <p className={styles.paragraph}>
                        We use the information we collect for the following purposes:
                    </p>
                    <ul className={styles.list}>
                        <li>To provide updates about your purchased units</li>
                        <li>To notify you of new offers, projects, and available units</li>
                        <li>To allow you to submit and track maintenance tickets</li>
                        <li>To display and manage your installment schedules</li>
                        <li>To improve our services and customer support</li>
                        <li>To comply with legal obligations</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Information Sharing and Disclosure</h2>
                    <p className={styles.paragraph}>
                        We do not sell your personal information. We may share it only in the
                        following cases:
                    </p>
                    <ul className={styles.list}>
                        <li>With service providers who assist in operating the app</li>
                        <li>If required by law, regulation, or legal process</li>
                        <li>To protect the rights, property, or safety of our users and company</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Data Security</h2>
                    <p className={styles.paragraph}>
                        We implement appropriate technical and organizational measures to protect
                        your data against unauthorized access, alteration, disclosure, or
                        destruction. However, please note that no method of transmission or
                        storage is completely secure.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Data Retention</h2>
                    <p className={styles.paragraph}>
                        We retain your personal and contract information only as long as
                        necessary to fulfill the purposes described in this policy, unless a
                        longer period is required by law.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Your Rights</h2>
                    <p className={styles.paragraph}>
                        You have the right to:
                    </p>
                    <ul className={styles.list}>
                        <li>Access, update, or delete your personal information</li>
                        <li>Request details about the data we hold about you</li>
                        <li>Opt out of receiving promotional notifications</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Children’s Privacy</h2>
                    <p className={styles.paragraph}>
                        Our app is intended for clients of Swag – For Contracting & Real Estate
                        Development. We do not knowingly collect data from children under 13.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Changes to This Privacy Policy</h2>
                    <p className={styles.paragraph}>
                        We may update this policy from time to time. Any changes will be posted in
                        the app with an updated "Last updated" date at the top.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Contact Us</h2>
                    <p className={styles.paragraph}>
                        If you have any questions about this Privacy Policy, please contact us:
                    </p>
                    <div className={styles.contactInfo}>
                        <p>Email: sales@swag-official.com</p>
                        <p>Phone: +20 1097 896 723</p>
                        <p>Address: Green towers, tower 19, second floor</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
